import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../../api/api';

const PAGE_SIZE = 15;

export default function HomeProjectsList() {

  const navigate = useNavigate();

  const [projects, setProjects] = useState([]);

  useEffect(() => {
    loadProjects();
  }, []);

  const loadProjects = async () => {

    try {

      const data = await apiFetch(
        '/datasets/list',
        {
          method: 'POST',
          body: {
            cnt: 0,
            lmt: PAGE_SIZE
          }
        }
      );

      let items = [];

      if (Array.isArray(data)) {
        items = data;
      }
      else if (
        data &&
        Array.isArray(data.items)
      ) {
        items = data.items;
      }

      setProjects(items);

    } catch (err) {

      console.error(
        'Failed loading projects',
        err
      );

    }

  };

  return (

    <div className="home-projects-card">

      <h3>Projects</h3>

      <p className="section-subtitle">
        Active projects
      </p>

      <ul className="home-project-list">

        {projects.map(project => (

          <li
            key={project._id}
            className="home-project-item"
            onClick={() =>
              navigate(
                `/datasets/actions/${project._id}`
              )
            }
          >
            {project.name}
          </li>

        ))}

      </ul>

    </div>

  );

}
